import { HStack, Text } from '@chakra-ui/react'
import Native from './native'
import { Form } from 'components'

export default function Checkbox({ label, ...props }){
    return(
    <HStack as="label" gap={4}>
        <Native {...props} />
        <Text fontSize="xs">{label}</Text>
    </HStack>
    )
}